var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableExportToExcelButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.099,
    height: 19.781,
    viewBox: "0 0 21.099 19.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5357",
    "data-name": "Path 5357",
    d: "M265.89,94.516h-9.231a.66.66,0,0,1-.659-.659V80.67a.66.66,0,0,1,.659-.659h9.231a.66.66,0,0,1,.659.659V93.857A.66.66,0,0,1,265.89,94.516Z",
    transform: "translate(-245.451 -77.373)",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11665",
    "data-name": "Group 11665",
    transform: "translate(10.549 5.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5358",
    "data-name": "Path 5358",
    d: "M259.3,145.33h-2.637a.659.659,0,0,1,0-1.319H259.3a.659.659,0,1,1,0,1.319Z",
    transform: "translate(-256 -144.011)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5359",
    "data-name": "Path 5359",
    d: "M259.3,209.33h-2.637a.659.659,0,1,1,0-1.319H259.3a.659.659,0,1,1,0,1.319Z",
    transform: "translate(-256 -205.374)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5360",
    "data-name": "Path 5360",
    d: "M259.3,273.33h-2.637a.659.659,0,1,1,0-1.319H259.3a.659.659,0,1,1,0,1.319Z",
    transform: "translate(-256 -266.736)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5361",
    "data-name": "Path 5361",
    d: "M259.3,337.33h-2.637a.659.659,0,1,1,0-1.319H259.3a.659.659,0,1,1,0,1.319Z",
    transform: "translate(-256 -328.099)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5362",
    "data-name": "Path 5362",
    d: "M385.978,145.33h-1.319a.659.659,0,0,1,0-1.319h1.319a.659.659,0,0,1,0,1.319Z",
    transform: "translate(-378.725 -144.011)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5363",
    "data-name": "Path 5363",
    d: "M385.978,209.33h-1.319a.659.659,0,0,1,0-1.319h1.319a.659.659,0,1,1,0,1.319Z",
    transform: "translate(-378.725 -205.374)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5364",
    "data-name": "Path 5364",
    d: "M385.978,273.33h-1.319a.659.659,0,1,1,0-1.319h1.319a.659.659,0,1,1,0,1.319Z",
    transform: "translate(-378.725 -266.736)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5365",
    "data-name": "Path 5365",
    d: "M385.978,337.33h-1.319a.659.659,0,1,1,0-1.319h1.319a.659.659,0,1,1,0,1.319Z",
    transform: "translate(-378.725 -328.099)",
    fill: "#388e3c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5366",
    "data-name": "Path 5366",
    d: "M11.629,16.142a.648.648,0,0,0-.542-.14L.538,17.98A.657.657,0,0,0,0,18.628V33.133a.659.659,0,0,0,.538.647l10.549,1.978a.62.62,0,0,0,.121.012.659.659,0,0,0,.659-.659V16.65A.658.658,0,0,0,11.629,16.142Z",
    transform: "translate(0 -15.989)",
    fill: "#2e7d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5367",
    "data-name": "Path 5367",
    d: "M85.755,166.185,83.67,163.8l2.109-2.711a.66.66,0,0,0-1.04-.811l-1.953,2.511-1.646-1.88a.659.659,0,0,0-.992.868l1.813,2.073-1.838,2.363a.66.66,0,0,0,1.042.81l1.681-2.163,1.917,2.19a.658.658,0,1,0,.992-.866Z",
    transform: "translate(-76.688 -154.091)",
    fill: "#fafafa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableExportToExcelButton);
export default __webpack_public_path__ + "static/media/table-export-to-excel-button.80d4d157d56761b69e3f800dd82d9c88.svg";
export { ForwardRef as ReactComponent };